import React, { useEffect, useRef } from "react";

import { API_ENDPOINT } from "../../../../constants/appConstant";
import { useNetwork } from "../../../../hooks/useNetwork";
import { EmailOTPSkeletonLoaderProps } from "../../../../types";

export const EmailOTPSkeletonLoader = ({
  updateStepHandler,
  email,
  toast,
  updateOTPIdHandler,
}: EmailOTPSkeletonLoaderProps) => {
  const btnRef = useRef<HTMLButtonElement>(null);
  const { fetchData: fetchAPI } = useNetwork();

  useEffect(() => {
    setTimeout(() => {
      if (btnRef.current) {
        btnRef.current.click();
      }
    }, 500);
  }, []);

  const getOTP = async () => {
    const res = await fetchAPI(
      `${API_ENDPOINT().seekerProfile.sendEmailOTPMiddleware}`,
      "POST",
      {},
      { email: email },
    );

    const id = (res?.data as any)?.id;

    if (id) {
      updateOTPIdHandler(id);
      updateStepHandler("EMAIL_OTP");
      toast({
        showToast: true,
        text: "OTP sent successfully",
        type: "success",
      });
    } else {
      toast({
        showToast: true,
        text: "Something went wrong!",
        type: "error",
      });
    }
  };

  return (
    <div className="l1-mx-auto l1-flex l1-w-full l1-animate-pulse l1-flex-col l1-items-center l1-gap-8 l1-py-5">
      <div className="l1-mt-4 l1-flex l1-w-full l1-flex-col l1-items-center l1-justify-center l1-gap-6 l1-px-6">
        <p className="l1-h-[52px] l1-w-full l1-bg-slate-200"></p>
      </div>
      <div className="l1-flex l1-w-full l1-flex-col l1-gap-4 l1-px-6">
        <div className="l1-h-[52px] l1-w-full l1-rounded-lg l1-bg-slate-200"></div>
        <p className="l1-h-[26px] l1-w-full l1-bg-slate-200"></p>
        <p className="l1-h-[26px] l1-w-full l1-bg-slate-200"></p>
        <div className="l1-h-[52px] l1-w-full l1-rounded-lg l1-bg-slate-200"></div>
        <p className="l1-h-[26px] l1-w-full l1-bg-slate-200"></p>
      </div>
      <button ref={btnRef} onClick={() => getOTP()} className="none" />
    </div>
  );
};
